<template>
  <div class="container index-container">
    <el-row :gutter="8">
      <el-col :xs="24" :sm="6" :md="6" :xl="6" :lg="6">
        <div class="search_box">
          <search-select
            placeholder="Year"
            v-model="searchkeywords['year']"
            :selectStatus="false"
            @change="searchMake(true)"
            :states="yearList"
            class="index-button"
          />
          <search-select
            placeholder="Make"
            v-model="searchkeywords['make']"
            :selectStatus="secondStatus"
            @change="searchModel(true)"
            :states="makeList"
            class="index-button"
          />
          <search-select
            placeholder="Model"
            v-model="searchkeywords['model']"
            @change="searchQualifier(true)"
            :selectStatus="thirdStatus"
            :states="modelList"
            class="index-button"
          />
          <search-select
            v-if="qualifierList.length > 0"
            placeholder="SubModel"
            v-model="searchkeywords['qualifier']"
            @change="searchBodytype(true)"
            :selectStatus="fourStatus"
            :states="qualifierList"
            class="index-button"
            :class="{ borderRed: hasSubmodel }"
          />
          <search-select
            v-if="bodytypeList.length > 0"
            placeholder="Bodytype"
            v-model="searchkeywords['bodytype']"
            :selectStatus="fiveStatus"
            :states="bodytypeList"
            class="index-button"
          />
          <el-button
            @click="handleClick"
            :class="{ disabled: submitFlag }"
            :disabled="submitFlag"
            class="index-button"
            >SEARCH <span class="btn-arrow"></span
          ></el-button>
        </div>
      </el-col>
      <el-col
        :xs="24"
        :sm="18"
        :md="18"
        :lg="18"
        :xl="18"
        v-loading="firstTabLoadingStatus"
      >
        <div v-if="tabData">
          <showcase :items="tabData" :searchParams="searchkeywords" />
        </div>

        <span v-if="noneFlag" class="err-info">
          Sorry. Currently no option under this product is compatible with your
          vehicle. Our team will be notified and we will consider adding the
          compatible products later.
        </span>
        <span v-if="hasSubmodel" class="err-info">
          Please select SubModel.
        </span>
      </el-col>
    </el-row>
    <div v-if="showSeo" class="seo_box">
      <h1>{{ showSeo.h1 }}</h1>
      <p>{{ showSeo.h1Answer }}</p>
      <div v-for="section in showSeo.h2" :key="section.title">
        <h2>{{ section.title }}</h2>
        <p>{{ section.h2Answer }}</p>
        <div v-for="subSection in section.h3" :key="subSection.title">
          <h3>{{ subSection.title }}</h3>
          <p>{{ subSection.h3Answer }}</p>
        </div>
      </div>
      <p>{{ showSeo.ClosingCTA }}</p>
    </div>
  </div>
</template>

<script>
import showcase from "@/components/showcase";
import searchSelect from "@/components/searchSelect";
import mixinsItem from "@/mixins/mixin";
export default {
  name: "modal",
  components: { searchSelect, showcase },
  mixins: [mixinsItem],
  data() {
    return {
      searchType: "HOME",
    };
  },
};
</script>

<style lang="less" scoped>
.index-button {
  width: 100% !important;

  @media (min-width: 600px) {
    width: 80% !important;
  }
}

.index-container {
  /*padding-top: 100px;*/
  padding-top: 0px;

  @media (min-width: 600px) {
    /*padding-left: 0px !important;*/
  }

  @media (max-width: 1079px) {
    /*padding: 0px 15px;*/
    /*padding-top: 80px;*/
    padding-top: 0px;
  }

  @media (max-width: 600px) {
    /*padding: 0px 15px;*/
    /*padding-top: 80px;*/
    padding-top: 0px;
  }
}

.search_box {
  position: sticky;
  /*top: 100px;*/
  top: 0px;

  @media (max-width: 1079px) {
    /*top: 80px;*/
    top: 0px;
  }

  @media (max-width: 600px) {
    position: initial;
  }
}
</style>

<style lang="less">
.container {
  /*padding: 0px 35px;*/
  @media (max-width: 800px) {
    /*padding: 0px 15px;*/
  }
  .el-row .el-col:first-child {
    margin-bottom: 20px;
    padding-bottom: 10px;
    /*@media (min-width: 600px) {*/
    /*  position: relative;*/
    /*  top: 10.5px;*/
    /*}*/
  }
}

.tabsShow {
  .el-tabs__header {
    display: none;
  }
}

@font-face {
  font-family: "Font Awesome 5 Pro";
  font-style: normal;
  font-weight: 400;
  src: url("../assets/fonts/fa-regular-400.eot");
  src: url("../assets/fonts/fa-regular-400.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/fonts/fa-regular-400.woff2") format("woff2"),
    url("../assets/fonts/fa-regular-400.woff") format("woff"),
    url("../assets/fonts/fa-regular-400.ttf") format("truetype"),
    url("../assets/fonts/fa-regular-400.svg#fontawesome") format("svg");
}

.btn-arrow:after {
  content: "\F054";
  display: inline-block;
  font-family: "Font Awesome 5 Pro";
  font-style: normal;
  font-weight: normal;
  margin-left: 0.88235294rem;
  width: 10px;
}

.borderRed {
  border: 2px solid #ff2626 !important;
}

.disabled {
  border: 2px solid #5c5c5c !important;
  // border-color: gray !important ;
  background-color: #232323 !important;

  span {
    color: #c0c4cc;
  }
}

.seo_box {
  text-align: left;
  color: #333;
  max-width: 1200px;
  margin: 10px auto;

  h1 {
    color: #333;
  }

  h2 {
    color: #333;
    font-weight: bold;
  }

  h3 {
    color: #333;
    font-weight: bold;
  }
}
</style>
